import React from 'react'

import GridElementContainer from '../../../GridElementContainer'
import Quizz from './Quizz'

import { useMainCategories } from '../../../../../../../hooks'

const Quizzes = ({ quizzes, containerClassName = '', className = '' }) => {
  const quizzesCount = (quizzes?.total_passed || 0) + (quizzes?.total_failed || 0)
  const quizzesPercent = quizzesCount ? ((quizzes?.total_completed || 0) / quizzesCount) * 100 : 0

  const mainCategories = useMainCategories()

  const inProgressContent = Array.isArray(quizzes?.in_progress_quizzes)
    ? quizzes.in_progress_quizzes.map((quizz) => (
        <Quizz key={quizz.quiz_hash} quizz={quizz} mainCategories={mainCategories} />
      ))
    : []

  return (
    <GridElementContainer className={containerClassName} title="Quizzes">
      {quizzes && (quizzesCount || inProgressContent.length) ? (
        <div className={`flex justify-between w-full ${className}`}>
          {/* Left Section - Stats */}
          <div className="borderViewLightPink w-[30%] flex flex-col rounded h-51 mr-2 p-2">
            <div className="mb-3">
              <div className="text-sm font-bold text-[#1AC057] text-center mb-1">
                {quizzesPercent.toFixed(0)}% Successful
              </div>
              <div className="w-full bg-white h-3 rounded-full border border-[#E6E6E6]">
                <div
                  className="h-full bg-[#1AC057] rounded-full transition-all duration-500 ease-out"
                  style={{ width: `${quizzesPercent}%` }}
                />
              </div>
            </div>

            <div className="mt-2 space-y-2">
              <div className="flex justify-between text-xs text-[#F79009] font-medium">
                <span>Started:</span>
                <span className="text-[#F67443]">{quizzesCount}</span>
              </div>
              <div className="flex justify-between text-xs text-[#F79009] font-medium">
                <span>Passed:</span>
                <span className="text-[#F67443]">{quizzes.total_passed || 0}</span>
              </div>
              <div className="flex justify-between text-xs text-[#F79009] font-medium">
                <span>Fail:</span>
                <span className="text-[#F67443]">{quizzes.total_failed || 0}</span>
              </div>
            </div>
          </div>

          {/* Right Section - In Progress */}
          <div className="orangeLightBorder w-[70%] rounded">
            <div className="mx-[8px] mb-[6px]">
              <span className="font-Inter not-italic font-bold text-sm text-[#F67443]">
                In Progress
              </span>
            </div>

            <div className="w-[calc(100%-1px)] px-[8px] overflow-y-auto primary-scroll max-h-[168px]">
              {inProgressContent}
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full h-full flex flex-col items-center justify-center border-[#FFCA84] border-[1px] p-[10px] rounded-[6px]">
          <img
            src="/assets/icon/empty-quizzes.svg"
            alt="Empty Quizzes"
            className="w-[124px] h-[124px]"
          />

          <p className="text-[20px] leading-[29px] text-primary-100 font-bold mt-[10px] text-center">
            Your Quiz Results Will Appear Here
          </p>
        </div>
      )}
    </GridElementContainer>
  )
}

export default Quizzes
